//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileUpload from "@/pccomponents/FileUpload";
import * as auth from "@/utils/auth";
import * as axios from "@/store/http";
export default {
    name: "staffentrybaseinfo",
    components: {
      FileUpload
    },
    props:{
        //业务数据
        record:{type:Object,default: () => ({})},
        //流程数据
        process:{type:Object,default: () => ({})},
        //规则绑定
        rules:{type: Object,default: () => ({})},
        //自定义的参数
        config: {type: Object, default: () => ({})},
        //是否不需要session
        passtoken:{type:Boolean,default:false}
    },
    data(){
        return{
            //性别
            genderList:[],
            //宗教信仰
            religionList:[],
            //进入公司来源
            insourceList:[],
            //婚姻状况
            marstatusList:[],
            //语言
            languageList:[],
            //常住地址居住类型
            peraddrtypeList:[],
            //当前地址居住类型
            curraddrtypeList:[],
            //人事管理员
            staffadminList:[],
            //称呼
            appellationList:[],
            //后缀
            suffixList:[],
            //国籍
            nationalityList:[],
            //姓名格式
            nameformatList:[],
            //账户类型
            accounttypeList:[],

            imageUrl:"",
            showImageFlag :false,
            keyval:"",
            fileids :[]
            // fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
            //url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        }
    },
    methods:{
      
    /**
     * 选择银行后回调函数
     */
      selectBankInfoBack(params){

        let returnVal = params.returnData;
        //有银行数据返回，则进行填值
        if (returnVal.length > 0 && this.isNotNullOrEmpty(returnVal[0].bankswift)) {
            this.$set(this.record, "openbank",returnVal[0].bankname);
            this.$set(this.record, "bankcountry",returnVal[0].country);
            this.$set(this.record, "bankcompanycode",returnVal[0].companycode);
            this.$set(this.record, "banktype",returnVal[0].banktype);
            this.$set(this.record, "bankswift",returnVal[0].bankswift);
            this.$set(this.record, "bankaddress",returnVal[0].bankaddress);
        }else{
            this.$set(this.record, "openbank","");
            this.$set(this.record, "bankcountry","");
            this.$set(this.record, "bankcompanycode","");
            this.$set(this.record, "banktype","");
            this.$set(this.record, "bankswift","");
            this.$set(this.record, "bankaddress","");
        }
      },
        /**
         * 获取附件信息
         */
        getImage(fileid){
          if(this.isNotNullOrEmpty(this.record.filerelateid)){
            this.getImageNotLogin(fileid);
          }else{
            this.getImageLogin(fileid);
          }
        },
        getImageLogin(fileid){
          var devflag = process.env.NODE_ENV;
          var protocol = document.location.protocol;
          var domain = window.location.host;
            if(fileid != ''){
               this.setfileid(fileid);
               var root =(devflag === 'development')?process.env.API_ROOT: protocol+"//"+domain+"/"+process.env.API_ROOT;
               let ffToken = auth.getToken();
               var timestamp = Date.parse(new Date()) / 1000;
               this.imageUrl=root+"file/getImage?fileid="+fileid+"&ffToken="+ffToken+"&timestamp="+timestamp;
                     
            }else{
               this.imageUrl = "";  
            }
        },
        getImageNotLogin(fileid){
          var devflag = process.env.NODE_ENV;
          var protocol = document.location.protocol;
          var domain = window.location.host;
            if(fileid != ''){
               this.setfileid(fileid);
               var root =(devflag === 'development')?process.env.API_ROOT: protocol+"//"+domain+"/"+process.env.API_ROOT;
               var timestamp = Date.parse(new Date()) / 1000;
               this.imageUrl=root+"onboarding/getImage?fileid="+fileid+"&timestamp="+timestamp;
                     
            }else{
               this.imageUrl = "";  
            }
        },
        /**
         *设置返回来的附件ID
         */
        setfileid(fileid){
            this.fileids = [];
            this.fileids.push(fileid);
            this.$parent.$parent.setFileid(fileid);
           // this.$set(this.record,"fileids",fileid);
        },
        /**
         *删除照片
         */
        delImage(){
          if(this.fileids.length > 0){
            let url = "file/delefilebyId";
            if(this.isNotNullOrEmpty(this.config.delImgUrl)){
              url = this.config.delImgUrl;
            }
            let params = {
                delfileids:this.fileids,
            }
            axios.post(url, params).then(({ data }) => {
                if (data.code == "1") {
                    this.tipSuccess(this.$t('staffentrybaseinfo.delscuphotip'));
                    this.imageUrl = "";
                    this.fileids = [];
                } else {
                    this.tipSuccess(this.$t('staffentrybaseinfo.delfailrphotip'));
                }
              });
            }
        },
        /**
         * 计算入司时间和参加工作时间
         */
        calcworkage(b_filed,t_field){
            let age = "";
            let worktime = this.record[b_filed];
            if(worktime != ''){
               let strworktime = worktime.split("-");
               let inYear = strworktime[2];
               let inMonth = strworktime[1];
               let inDay = strworktime[0];
               let d = new Date();
               let nowYear = d.getFullYear();
               let nowMonth = d.getMonth() + 1;
               let nowDay = d.getDate();
               if(inYear == nowYear){
                   age = 0;
               }else{
                   let ageDiff = nowYear - inYear ; //年之差
                   if(ageDiff > 0){
                        //月份相等则判断是否过日期
                        if(inMonth == nowMonth) {
                            var dayDiff = nowDay - inDay;//日之差
                            if(dayDiff < 0)
                            {
                                age = ageDiff - 1;
                            }
                            else
                            {
                                 age = ageDiff ;
                            }
                        }else{
                            var monthDiff = nowMonth - inMonth;//月之差
                            if(monthDiff < 0)
                            {
                                age = ageDiff - 1;
                            }
                            else
                            {
                                age = ageDiff ;
                            }
                        }
                   }else{
                      age = -1; 
                   }
               }
            }
            this.$set(this.record,t_field,age);

        },
        /**
         * 初始化下拉框
         */
        initSelect(){
          let p_gender = {
            showcode:'genderList',
            selectcode:'SYS_CDFCODECONFIG',
            hasnull:false,
            paras:{"paras0":"GENDER","paras1":"1"}
          };
          let p_religion = {
            showcode:'religionList',
            selectcode:'SYS_CDFCODECONFIG',
            hasnull:false,
            paras:{"paras0":"RELIGION","paras1":"1"}
          };
          let insourceType="INSOURCE";
          if(this.config.btype=="SECONDED"){
            insourceType="SECONDINSOURCE"
          }
          let p_insource = {
              showcode:'insourceList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":insourceType,"paras1":"1"}
          };
          let p_marstatus = {
              showcode:'marstatusList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"MARSTATUS","paras1":"1"}
          };
          let p_language = {
              showcode:'languageList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"LANGUAGE","paras1":"1"}
          };
          let p_peraddrtype = {
              showcode:'peraddrtypeList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"ACCOMMODATION","paras1":"1"}
          };
          let p_curraddrtype = {
              showcode:'curraddrtypeList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"INHABITTYPE","paras1":"1"}
          };
          let p_accounttype = {
              showcode:'accounttypeList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"ACCOUNTTYPE","paras1":"1"}
          };
          let p_staffadmin = {
              showcode:'staffadminList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"STAFFADMIN","paras1":"1"}
          };
          let p_appellation = {
              showcode:'appellationList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"APPELLATION","paras1":"1"}
          };
          let p_suffix = {
              showcode:'suffixList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"SUFFIX","paras1":"1"}
          };
          let p_nationality = {
              showcode:'nationalityList',
              selectcode:'SYS_BNATIONALITY',
              hasnull:false,
              paras:{}
          };
           let p_nameformat = {
              showcode:'nameformatList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"NAMEFORMAT","paras1":"1"}
          };
          let params = [];
          params.push(p_gender);
          params.push(p_religion);
          params.push(p_insource);
          params.push(p_marstatus);
          params.push(p_language);
          params.push(p_peraddrtype);
          params.push(p_curraddrtype);
          params.push(p_accounttype);
          params.push(p_staffadmin);
          params.push(p_appellation);
          params.push(p_suffix);
          params.push(p_nationality);
          params.push(p_nameformat);
          if(this.isNotNullOrEmpty(this.config.dropUrl)){
            this.initDropDownWithUrl(this,params,this.config.dropUrl);
          }else{
            this.initDropDown(this,params);
          }
        },
        /**
         * 校验生日不能早于今天
         */
        async checkbirthday(){  
          if(this.record.birthday!=null && this.record.birthday !='')
          {
            let birthday=this.forMatDate(this.record.birthday);
            var t_day = new Date();
            var month = t_day.getMonth()+1;
            if(month < 10){
              month = "0"+month;
            }

            var day =  t_day.getDate();
            if(day <10){
              day = "0"+day;
            }
            var today =  t_day.getFullYear()+"-" + month + "-" + day;
            //计算时间几个月份
            if (birthday >= today) {
              return false
            }
            else{
              return true
            }
          }
          else
          {
            return true
          }
    },
    async validateMobile(dataObj, dataAttrName, eventObj){
      var oValue = eventObj.target.value;
      var reg =/^[0-9]*$/;
      // 要求输入为整数
      if(!reg.test(oValue)){
        oValue = oValue.replace(/[^\d]/g, "");
        this.$set(dataObj, dataAttrName, '');
      }
     
    }
    },
    created(){
        this.initSelect();
    },
}




// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentrybaseinfo.vue